import { Box, Chip, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import type { FC } from "react";

interface PercentageCellProps {
  value?: number;
  percentage: number;
}

const FIRST_THRESHOLD = 20;
const SECOND_THRESHOLD = 50;

export const PercentageCell: FC<PercentageCellProps> = ({
  value,
  percentage,
}) => {
  const { colors, customFontWeight } = useTheme();

  return (
    <Box width="100%">
      <Stack
        direction="row"
        alignItems="center"
        sx={{
          gap: 1,
          display: "inline-flex",
        }}
      >
        {value !== undefined && (
          <Typography variant="body2">{value}</Typography>
        )}
        <Chip
          label={`${percentage}%`}
          size="small"
          sx={{
            backgroundColor:
              percentage <= FIRST_THRESHOLD
                ? colors.background.brandTertiary
                : percentage < SECOND_THRESHOLD
                  ? colors.background.warningTertiary
                  : colors.background.successTertiary,
            color: colors.text.brandPrimary,
            "& .MuiChip-label": {
              color:
                percentage <= FIRST_THRESHOLD
                  ? colors.text.brandPrimary
                  : percentage < SECOND_THRESHOLD
                    ? colors.text.warning
                    : colors.text.success,
              fontWeight: customFontWeight.medium,
            },
          }}
        />
      </Stack>
    </Box>
  );
};
